import { useEffect, useState } from 'react';
import storage from '../Storage';
import { useAuth } from '../context/AuthProvider';

const useLoadUserFromLocalStorage = () => {
  const [isLocalStorageLoaded, setIsLocalStorageLoaded] = useState(false);
  const { isLoggedIn, login } = useAuth();

  useEffect(() => {
    const checkLocalStorageUser = async () => {
      let user = await storage.get('user');
      console.log('USER FROM LOCAL STORAGE', user);
      if (!isLocalStorageLoaded) {
        login(user);
        setIsLocalStorageLoaded(true);
      }
    };
    checkLocalStorageUser();
  }, []);

  return { isLocalStorageLoaded };
};

export default useLoadUserFromLocalStorage;
